/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Checkbox, Divider, Input } from 'antd';
import { useEffect, useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { StepsButton } from './BtnSave';
import DPIAService from '../../../services/DPIA.service';

import init from './init.json';
import { useDpiaContext } from '../dpia.context';

export const LASTID = 'fd1c9eb8629411ee867dfa163e89e3c8';

export const checkValidForm = (fields, values) => {
    for (const [key, value] of Object.entries(values)) {
        if (fields.includes(key) && (!value || value?.length === 0)) {
            return false;
        }
    }
    return true;
};

export default function Step1(props) {
    const { t } = useTranslation(['translation', 'dpia']);

    const { setIdentificationList: _setIdentificationList } = useDpiaContext();

    const dpiaIdentificationList = Form.useWatch(
        'dpiaIdentificationList',
        props.form
    );
    const lastId = Boolean(dpiaIdentificationList?.find((d) => d === LASTID));
    const { setStepNo } = useDpiaContext();

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                props.setStep1(true);
            })
            .catch(() => props.setStep1(false));
        props.nextStep();
    };
    const [identificationList, setIdentificationList] = useState([]);

    useEffect(() => {
        setStepNo(2)
    }, []); 


    useEffect(() => {
        const getDPIAIndentification = async () => {
            try {
                const { data } = await DPIAService.getDPIAIdentification();
                if (data?.resultData) {
                    setIdentificationList(data?.resultData);
                    _setIdentificationList(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getDPIAIndentification();
    }, []);

    const disabled = (id) => {
        if (lastId) {
            if (id === LASTID) {
                props.form.setFieldValue('dpiaIdentificationList', [LASTID]);
                return { disabled: false };
            } else return { disabled: true };
        }
        return { disabled: false };
    };

    const onValuesChange = (change, allValues) => {
        const fields = ['dpiaIdentificationList', 'reason'];
        const check = checkValidForm(fields, allValues);
        props.setStep1(check);
    };

    return (
        <div hidden={!props?.isActive}>
            <div className="flex border-b border-x-0 border-t-0 border-gray-light border-solid">
                <div>
                    <h1 className="text-2xl font-semibold text-purple">
                        {t('step 1')} : {t('DPIA Indentification')}
                    </h1>
                    <p className="text-sm text-gray-PHX">
                        {t('DPIA step 1 description')}
                        <span>
                            <a
                                className="text-new underline px-2 hover:text-new hover:underline"
                                href="https://www.law.chula.ac.th/wp-content/uploads/2020/12/TDPG3.0-C5-20201224-1.pdf"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {t('Thailand Data Protection Guidelines 3.0')}
                            </a>
                        </span>
                        {t('section E1')}
                    </p>
                </div>
                <hr />
            </div>
            <div className="mt-3.5">
                <p className="text-xl font-semibold mb-0">
                    {t(
                        'Should the following tasks be subject to a data protection impact assessment'
                    )}{' '}
                    <span className="text-error">*</span>
                </p>
                <p className="text-sm text-gray-dark">
                    {t(
                        'Do these list under the high-risk category for potentially impacting individuals and rights'
                    )}
                </p>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    initialValues={init.identification}
                    onValuesChange={onValuesChange}
                    name="identification"
                    layout="vertical"
                    form={props.form}
                >
                    <p className="text-sm text-error font-semibold">
                        {props.form.getFieldError('dpiaIdentificationList')}
                    </p>
                    <Form.Item
                        name="dpiaIdentificationList"
                        rules={[
                            {
                                required: true,
                                message: t('errorText.validateSelect2'),
                            },
                        ]}
                        help=""
                    >
                        <Checkbox.Group className="w-full mb-1">
                            {identificationList.map((is) => {
                                return (
                                    <Fragment key={is.mDpiaIdentificationId}>
                                        {is.sequence === 15 ? <Divider /> : ''}
                                        <Checkbox
                                            {...disabled(
                                                is.mDpiaIdentificationId
                                            )}
                                            value={is.mDpiaIdentificationId}
                                            style={{ lineHeight: '32px' }}
                                        >
                                            {is.dpiaIdentificationName}
                                        </Checkbox>
                                        <br />
                                    </Fragment>
                                );
                            })}
                        </Checkbox.Group>
                    </Form.Item>
                    {lastId && (
                        <Form.Item
                            name="reason"
                            label={t(
                                'Reasons why it is not necessary to prepare a DPIA',
                                { ns: 'dpia' }
                            )}
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Input.TextArea
                                rows={4}
                                placeholder={t(
                                    'Enter your reason for disagreement'
                                )}
                                maxLength={250}
                                showCount
                            />
                        </Form.Item>
                    )}
                    <Form.Item name="dpiaName" hidden />
                    <Form.Item name="dpiaId" hidden />
                </Form>
            </div>
            <Divider />
            <StepsButton previous={props?.back} next={onNextStep} />
        </div>
    );
}
